import { axiosGet } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { ReadStakeDbPoolsParams } from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 풀 타이틀 목록 조회
export const readStakeDbPoolTitles = async () => {
  const payload: EndpointPayload = {
    path: '/assetfi/admin/staking/pools/titles',
    apiUrl: BALANCE_API_URL,
  };

  return await sendRequest(payload, 'readStakeDbPoolTitles', axiosGet);
};

// 단일 풀 상세 조회
export const readStakeDbPoolDetail = async (poolId: string) => {
  const payload: EndpointPayload = {
    path: `/assetfi/admin/staking/pools/${poolId}`,
    apiUrl: BALANCE_API_URL,
  };

  return await sendRequest(payload, 'readStakeDbPoolDetail', axiosGet);
};

// 풀 목록 조회
export const readStakeDbPools = async (params?: ReadStakeDbPoolsParams) => {
  const queryParams = new URLSearchParams();

  if (params?.walletAddress) {
    queryParams.append('walletAddress', params.walletAddress);
  }
  if (params?.state !== undefined) {
    queryParams.append('state', String(params.state));
  }
  if (params?.page !== undefined) {
    queryParams.append('page', String(params.page));
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', String(params.limit));
  }

  const queryString = queryParams.toString();
  const path = `/assetfi/admin/staking/pools${queryString ? `?${queryString}` : ''}`;

  const payload: EndpointPayload = {
    path,
    apiUrl: BALANCE_API_URL,
  };

  return await sendRequest(payload, 'readStakeDbPools', axiosGet);
};
